export function flatten<T>(arr: T[][]): T[] {
    const result: T[] = []
    arr.forEach((a) => a.forEach((b) => result.push(b)))
    return result
}
